import { createSlice } from '@reduxjs/toolkit';

const signageSlice = createSlice({
  name: 'signage',
  initialState: {
      id: "",
      current: 0,
      menuid: '',
      hasUnsavedChanges: false
  },
  reducers: {
    signageRequested: (state, action) => {
      state.id = action.payload.id;
      state.current = action.payload.current;
      state.menuid = action.payload.menuid;
    },
    signageDelete: (state) => {
      state.id = "";
      state.current = 0;
      state.menuid = '';
      state.hasUnsavedChanges = false;
    },
    setUnsavedChanges: (state, action) => {
      state.hasUnsavedChanges = action.payload;
    }
  }
});

export const {
  signageRequested,
  signageDelete,
  setUnsavedChanges
} = signageSlice.actions;

export default signageSlice.reducer;